export const pushAnalytics = (...args) => {
    // Check if gtag is available (Google Analytics may not be loaded)
    if (typeof window !== 'undefined' && window.gtag && typeof window.gtag === 'function') {
        try {
            const payload = ["event", ...args];
            window.gtag.apply(this, payload);
        } catch (error) {
            console.warn('Analytics error:', error);
        }
    } else {
        // Silently ignore if analytics is not available
        if (process.env.NODE_ENV === 'development') {
            console.log('Analytics not available, event:', args);
        }
    }
};